export const errors = {
    required: 'Required',
    invalid: 'Sorry, that\'s an invalid entry'
};
